/**
 * Validators
 */
export function isPyodideConvertiblePrimitive(value) {
    return (typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean" ||
        value === null ||
        value === undefined);
}
export function isStreamlitConfig(value) {
    return (typeof value === "object" &&
        value != null &&
        Object.entries(value).every(([key, value]) => typeof key === "string" && isPyodideConvertiblePrimitive(value)));
}
export function assertStreamlitConfig(value) {
    if (!isStreamlitConfig(value)) {
        throw new Error(`Invalid streamlitConfig: ${value}`);
    }
}
//# sourceMappingURL=types.js.map